import { useParams, Link } from "react-router-dom";
import LevelLayout from "../components/training/LevelLayout";
import { SLUG_TO_LVL } from "../components/training/trainingData";

export default function LevelPage() {
  const { slug } = useParams();
  const lvl = SLUG_TO_LVL[slug];

  if (!lvl) {
    return (
      <div className="bg-black text-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-[32px] font-bold mb-4">Level not found</h1>
          <Link to="/" className="text-[#a3e635] hover:underline">
            Back to training
          </Link>
        </div>
      </div>
    );
  }

  return <LevelLayout lvl={lvl} />;
}
